import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import ALA from "../images/ALA-CARTE-CHANNEL.pdf";
import MTP from "../images/MUTIPLE-TV-POLICY.pdf";
import MOP from "../images/MANUAL OF PRACTICE For Fastway.pdf";
import CarriageRIO from "../images/CarriageRIO.pdf";
import Broadcaster from "../images/Broadcaster.pdf";
import NetworkCapacityFee from "../images/Network Capacity Fee.pdf";
import STBOption from "../images/STB-OPTION.pdf";
import DeclarationUnderSec4 from "../images/DeclarationUnderSec4.pdf";
import axios from "axios";

var decodeHTML = function (html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

function createMarkup(content) {
  return { __html: decodeHTML(content) };
}

export const Footer = (props) => {
  const [pagedata, setPagedata] = useState([]);
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      const response = await axios.get(
        window.weburl + `api/get_plans2.php?cid=cp`
      );
      if (mounted) {
        setPagedata(response.data);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  const [pagedata2, setPagedata2] = useState([]);
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      const response = await axios.get(
        window.weburl + `api/get_plans2.php?cid=at`
      );
      if (mounted) {
        setPagedata2(response.data);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  const [pagedata3, setPagedata3] = useState([]);
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      const response = await axios.get(
        window.weburl + `api/get_plans2.php?cid=hd`
      );
      if (mounted) {
        setPagedata3(response.data);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  console.log(pagedata);
  if (pagedata.length === 0) {
    console.log("no data");
    // return null;
  }

  const [urlvalue, seturlvalue] = useState("");
  useEffect(() => {
    axios
      .get(window.weburl + "api/get_urls.php")
      .then((response) => seturlvalue(response.data))
      .catch((error) => console.log(error));
  }, []);
  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div
              className="footer"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="600"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              <div className="ftrbox">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlSpace="preserve"
                  width={960}
                  height={405.906}
                  style={{
                    shapeRendering: "geometricPrecision",
                    textRendering: "geometricPrecision",
                    imageRendering: "optimizeQuality",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                  }}
                  viewBox="0 0 25399.98 10739.61"
                  {...props}
                >
                  <defs>
                    <style>
                      {".footer .fil2{fill:#4b4b4d;fill-rule:nonzero}"}
                    </style>
                  </defs>
                  <g id="Layer_x0020_1">
                    <g id="_3144284107216">
                      <path
                        d="M9408.48 1064.21c0-1418.91 2222.81-1418.97 2222.81 0 0 1373.93-2222.81 1373.93-2222.81 0z"
                        style={{
                          fill: "#f58634",
                        }}
                      />
                      <path
                        d="M3939.29 2414.3v3970.62c0 675.83-163.47 1189.88-490.5 1541.84-326.98 352.05-786.28 528.03-1378.03 528.03-638.31 0-1143.08-191.52-1514.16-574.53C185.52 7497.23 0 6939.71 0 6207.47h1510.29c0 501.32 163.48 751.98 490.51 751.98 275.04 0 412.59-191.58 412.59-574.53V2414.3h1525.9zm5174.56 1258.72v4739.55H7587.88v-794.14c-124.56 253.41-306.24 456.22-544.95 608.24-238.73 152.05-519.03 228.06-840.8 228.06-503.49 0-899.23-181.62-1187.19-544.89-288.12-363.28-432.14-860.32-432.14-1491.04V3673.02h1525.89v2543.01c0 270.34 66.12 482.92 198.55 637.83 132.35 154.84 310.1 232.26 533.28 232.26 228.34 0 409.99-78.82 544.95-236.48 134.9-157.7 202.41-380.26 202.41-667.46V3673.02h1525.97zm5820.4-42.16c503.43 0 897.89 181.62 1183.4 544.9 285.43 363.27 428.12 857.5 428.12 1482.61v2754.2h-1518.09V5869.68c0-276.01-66.19-491.48-198.54-646.32-132.35-154.91-310.11-232.32-533.28-232.32-228.4 0-410 80.16-544.96 240.75-134.96 160.53-202.41 381.55-202.41 663.12v2517.66H12014.8V2160.81h1533.69v2306.35c124.57-253.41 306.17-456.16 544.96-608.26 238.73-152.03 519.02-228.04 840.8-228.04zm4427.05 1436.2c-238.65 0-432.06 85.85-579.86 257.67-147.96 171.78-221.95 409.65-221.95 713.92 0 309.75 73.99 550.49 221.95 722.27 147.8 171.76 341.21 257.69 579.86 257.69 228.46 0 417.86-87.32 568.35-261.91 150.56-174.65 225.87-413.92 225.87-718.05 0-298.57-75.31-535.11-225.87-709.7-150.49-174.65-339.89-261.89-568.35-261.89zm-505.96-1453.13c306.24 0 572.22 71.8 798 215.48 225.73 143.6 393.07 342.04 502.18 595.59v-751.98h1525.81v4739.55h-1525.81v-751.92c-109.11 253.47-276.45 451.93-502.18 595.53-225.78 143.75-491.76 215.54-798 215.54-347.76 0-661.71-97.17-942.02-291.55-280.24-194.24-500.85-475.89-661.71-844.8-160.95-368.89-241.32-801.15-241.32-1296.72 0-495.7 80.37-926.57 241.32-1292.65 160.86-366.1 381.47-646.34 661.71-840.58 280.31-194.4 594.26-291.49 942.02-291.49zm5073.31 1049.23c171.29-281.57 386.68-506.88 646.12-675.75 259.52-168.98 534.7-253.55 825.21-253.55v1671.1h-443.65c-342.57 0-599.54 71.81-770.74 215.39-171.36 143.69-256.94 392.87-256.94 747.72v2044.5h-1533.67l-21.09-4739.55h1554.76v990.14zM10519.9 2471.69c-272.53 0-512.22-48.61-720.74-143.52v6557.48c0 129.55-28.46 223.82-85.63 282.98-57.06 59.15-150.49 88.72-280.18 88.72h-327.03v1419.33h537.17c1121.01 0 1681.58-605.51 1681.58-1816.4V2285.52c-227.14 123.14-494.95 186.17-805.17 186.17z"
                        style={{
                          fill: "#ee3147",
                        }}
                      />
                      <path
                        d="M15741.99 9803.42h644.98v843.95c-104.81 34.13-203.09 58.03-295.33 71.73-92.24 13.7-186.81 20.51-283.2 20.51-245.24 0-432.4-72.15-561.88-216.39-129.48-144.3-193.96-351.19-193.96-621.1 0-262.67 74.73-467.31 225.09-614.22 149.99-146.97 358-220.25 624.13-220.25 166.98 0 328.01 33.46 482.84 100.27l-114.59 275.59c-118.45-59.22-241.87-88.8-370.16-88.8-149.22 0-268.43 50.09-358 150.28-89.99 99.89-134.76 234.65-134.76 403.6 0 176.54 36.04 311.28 108.55 404.3 72.15 93.02 177.32 139.66 315.09 139.66 71.79 0 145.07-7.59 219.05-22.33v-339.81h-307.85v-286.99zM17368.46 9812.54h111.2c109.04 0 189.47-18.26 241.11-54.66 51.99-36.11 77.84-93.44 77.84-171.26 0-77.01-26.62-132.1-79.38-164.76-53.11-32.6-135.17-48.96-246.38-48.96h-104.39v439.64zm0 280.18v624.13h-344.67V9090.49h473.72c220.95 0 384.22 40.25 490.15 120.68 106.3 80.52 159.05 202.75 159.05 366.38 0 95.67-26.2 180.69-78.96 255.5-52.41 74.4-126.81 132.85-223.26 175.01 244.47 365.59 403.96 602.13 478.01 708.79h-382.68l-388.01-624.13h-183.35zM20253.04 9901.76c0 269.56-66.45 476.45-200.08 621.1-133.6 144.64-324.98 216.73-573.96 216.73-249.05 0-440.41-72.09-574.03-216.73-133.63-144.65-200.08-352.32-200.08-623.01 0-270.68 66.81-477.57 200.85-620.33 133.63-142.75 325.7-214.14 575.51-214.14 249.82 0 441.12 71.73 573.27 215.69 132.49 143.88 198.52 350.77 198.52 620.69zm-1186.71 0c0 181.87 34.49 318.53 103.22 410.77 69.12 91.88 172.4 137.83 309.45 137.83 275.19 0 412.68-183.02 412.68-548.6 0-366.38-136.71-549.32-410.43-549.32-137.41 0-240.69 46.3-310.51 138.55-69.48 92.24-104.41 229.29-104.41 410.77z"
                        className="fil2"
                      />
                      <path
                        d="M22163.12 9090.45v1052.75c0 119.92-26.99 225.51-80.52 315.86-53.88 90.69-131.29 159.83-233.09 208.02-101.72 48.19-221.73 72.51-360.61 72.51-208.86 0-371.28-53.55-487.06-160.97-115.84-107.06-173.54-253.6-173.54-439.98V9090.45h343.55v995.77c0 125.68 25.43 217.59 75.59 276.03 50.52 58.87 134.04 88.11 250.52 88.11 112.76 0 194.38-29.66 245.26-88.52 50.93-58.81 76.36-151.47 76.36-277.51v-993.88h343.54z"
                        style={{
                          fill: "#4b4b4d",
                        }}
                      />
                      <path
                        d="M23155.2 9855.8h113.54c106.28 0 185.6-20.87 238.01-63.01 52.75-41.74 78.96-102.86 78.96-183.01 0-80.88-21.98-140.44-66.04-179.15-44.05-38.36-113.11-57.75-207.66-57.75h-156.81v482.92zm778.61-258.17c0 175.06-54.64 309.03-163.95 401.69-109.33 92.6-265 138.96-466.55 138.96h-148.11v578.55h-344.65V9090.45h519.3c197.41 0 347.33 42.52 450.26 127.23 102.5 85.02 153.7 211.83 153.7 379.95z"
                        className="fil2"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>Call</li>
                  <li>
                    <a href="tel:+911614044444">+91-161-4044444</a>
                  </li>
                </ul>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>Email</li>
                  <li>
                    <a href="mailto:corporate@jujhargroup.com">
                      corporate@jujhargroup.com{" "}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>Address</li>
                  <li>Jujhar Corporate Office</li>
                  <li>
                    Level 5, Grand Walk <br /> Ferozepur Road <br /> Ludhiana
                    141012, Punjab
                  </li>
                </ul>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>Follow</li>
                  <li>
                    <a
                      href="https://www.facebook.com/FastwayDigitalTV"
                      target="_blank"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/fastwaydigitaltv/"
                      target="_blank"
                    >
                      Instagram
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/2771798/admin/">
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/FastwayCableTV"
                      target="_blank"
                    >
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/c/FastwayOfficial"
                      target="_blank"
                    >
                      Youtube
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="footer m-0"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="600"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              <div className="ftrbox">
                <ul>
                  <li>
                    <NavLink to="/fastway-exclusive">Fastway Exclusive</NavLink>{" "}
                  </li>
                </ul>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>Digital TV</li>
                  {urlvalue ? (
                    <>
                      {urlvalue.map((urlVal) => (
                        <li>
                          <a href={"/digital-tv/" + urlVal.slug}>
                            {urlVal.flag}
                          </a>
                        </li>
                      ))}
                    </>
                  ) : null}

                  <li>
                    <a href={ALA} target="_blank">
                      Ala-Carte
                    </a>
                  </li>
                  <li>
                    <NavLink to="/digital-tv/fastway-hd-plus-packs">
                      Upgrade
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>
                    <NavLink to="/channel-packs">Channel Packs</NavLink>{" "}
                  </li>
                  {pagedata.map((planData) => (
                    <li>
                      <a href={"/digital-tv/" + planData.slug}>
                        {planData.pname}
                      </a>{" "}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>
                    <NavLink to="/ip-tv">IPTV</NavLink>
                  </li>
                  {pagedata2.map((planData) => (
                    <li>
                      <a
                        href={"/ip-tv"}
                        dangerouslySetInnerHTML={createMarkup(planData.pname)}
                      ></a>{" "}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="ftrbox">
                <ul>
                  <li>
                    <NavLink to="/ip-tv">BBAPPIPTV</NavLink>
                  </li>

                  <li>
                    <a href={"/2ip-tv"}></a>{" "}
                  </li>
                </ul>
              </div>
              {/* <div className="ftrbox">
                <ul>
                  <li>
                    <NavLink to="/fastway-hd-bundle"> HD Bundle</NavLink>
                  </li>
                  {pagedata3.map (planData => (
                                <li><a href={"/fastway-hd-bundle"} dangerouslySetInnerHTML={createMarkup(planData.pname)}></a> </li>
                                ))}
                </ul>
              </div> */}
              <div className="ftrbox">
                <ul>
                  <li>Channel Policy</li>
                  <li>
                    <a href={Broadcaster} target="_blank">
                      Broadcaster Package Rates
                    </a>
                  </li>
                  <li>
                    <a href={NetworkCapacityFee} target="_blank">
                      Network Capacity Fee
                    </a>
                  </li>
                  <li>
                    <a href={STBOption} target="_blank">
                      STB Option
                    </a>
                  </li>
                  <li>
                    <NavLink to="/refund-policy">Refund Policy</NavLink>
                  </li>
                  <li>
                    <a href={DeclarationUnderSec4} target="_blank">
                      Declaration Under Sec 4(4)
                    </a>
                  </li>
                  <li>
                    <a href={CarriageRIO} target="_blank">
                      Rio Carriage Draft
                    </a>
                  </li>
                  <li>
                    <a href={MOP} target="_blank">
                      Manual of Practice (MoP)
                    </a>
                  </li>
                  {/* <li>
                    <a href={MTP} target="_blank">
                    Multiple Tv Policy
                    </a>
                  </li> */}
                  <li>
                    <NavLink to="/disclaimer">Disclaimer</NavLink>{" "}
                  </li>
                  <li>
                    <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                  </li>
                  <li>
                    <NavLink to="/terms-conditions">Terms & Conditions</NavLink>{" "}
                  </li>
                  <li>
                    <NavLink to="/faqs">FAQs</NavLink>
                  </li>
                </ul>
              </div>
              <div className="ftrbox">
                <ul>
                  <li>Fastway Transmissions</li>
                  <li>
                    <NavLink to="/about-fastway">About Fastway</NavLink>
                  </li>
                  <li>
                    <NavLink to="/our-management">Our Management</NavLink>
                  </li>
                  <li>
                    <NavLink to="/our-technology">Our Technology</NavLink>
                  </li>
                  <li>
                    <NavLink to="/about-jujhar">Jujhar Group</NavLink>
                  </li>
                  <li>
                    <a
                      href="https://www.jujhargroup.com/career/"
                      target="_blank"
                    >
                      Career
                    </a>
                  </li>
                  <li>
                    <NavLink to="/download">Downloads</NavLink>
                  </li>
                  <li>
                    <NavLink to="/faqs">Consumer Corner</NavLink>
                  </li>
                  <li>
                    <NavLink to="/live-tv">Live TV</NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="copyrights">
              <p>
                &copy; 2026 Fastway Transmissions Private Limited | all rights
                reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
